module.exports = __webpack_public_path__ + "img/check.1f2d37e4.png";